(() => {
  for (const catalog of document.querySelectorAll('[data-bba-catalog]')) {
    const prepare = node => {
      if (!(node instanceof Element)) return;
      for (const image of node.querySelectorAll('.card__media .media--hover-effect > img + img')) image.loading = 'eager';
    };
    prepare(catalog);
    new MutationObserver(changes => {
      for (const change of changes) for (const node of change.addedNodes) prepare(node);
    }).observe(catalog, { childList: true, subtree: true });
  }
})();
